import { IListElementCellBase } from './list-element-cell-base.interface';
import { IListElementCell } from './list-element-cell.interface';

import { TPriceDisplayMode } from '../../list-column';
import { TState } from '../../tstate.type';
import { IValue } from '../../value.interface';

/**
 * Sign displaying policy
 * auto - display as usual. Default value
 * invert - display as usual but with inverted sign
 * force - force displaying value sign. Allow to display plus sign
 * negative - force displaying minus sign
 * positive - force displaying plus sign
 */
export type PriceSign = 'auto' | 'force' | 'invert' | 'negative' | 'positive';

/**
 * Period enum on BE
 * -200 - transfer
 * -100 - trial
 * -50 - day
 * 0 - lifetime
 * 1 - one month
 * 3 - three month
 * 6 - half year
 * 12 - one year
 * 24 - two years
 * 36 - three years
 * 48 - four years
 * 60 - five years
 * 120 - ten years
 */
export type TPeriod =
  // eslint-disable-next-line @typescript-eslint/sort-type-union-intersection-members
  | '-200'
  | '-100'
  | '-50'
  | '0'
  | '1'
  | '3'
  | '6'
  | '12'
  | '24'
  | '36'
  | '48'
  | '60'
  | '120';

export interface IPrice {
  cost: IValue;
  currency: IValue;
  /** Force sign for cost */
  sign?: IValue<PriceSign>;
  period?: IValue<TPeriod>;
  show_period?: IValue<TState>;
  /** Price for the period specified in the tariff settings */
  period_cost?: IValue;
  /** Calendar payment date (fixed day of the month when you need to pay) */
  prorata_date?: IValue;
  min_period_msg?: IValue;
  /**
   * Date until which service will be paid in accordance with selected period
   * (for time being, only come for case when service has a cost per installation)
   */
  expire_date?: IValue;
  /** Daily payment */
  daily?: IValue;
  tax_amount?: IValue;
  /** Tax exclusive: on - tax is not included in cost, off - tax is included in cost */
  tax_exclusive?: IValue<TState>;
  tax_rate?: IValue;
  discount?: IValue;
  discount_percent?: IValue;
  no_discount_cost?: IValue;
  /** Discount by special price */
  $special_price?: 'yes';
  /** Number of days in the trial period */
  trial?: IValue;
  /** End message for the number of days of the trial period ('day' | 'days') */
  trial_msg?: IValue;
  /** Possible prolong cost after end of trial period, when autoprolong is enabled */
  price_after_trial?: IValue;
  /** Possible prolong period after end of trial period */
  price_after_trial_period?: IValue<TPeriod>;
  /**
   * Possible cost for minimum available period after end of trial period
   * when autoprolong is not enabled
   */
  price_after_trial_noautoprolong?: IValue;
  /* Hint for calendar payment */
  prorata_hint?: IValue;
}

export interface IListElementPriceCell extends IListElementCellBase {
  price: IPrice | IPrice[];
  $display_type?: TPriceDisplayMode;
  /** Key for model */
  $key?: string;
}

/**
 * Check cell on price type
 *
 * @param cell
 */
export function isPriceCell(
  cell: IListElementCell,
): cell is IListElementPriceCell {
  return 'price' in cell;
}
